import styled from "styled-components";
import {Styles} from "@/styles/index";

export const Div = styled.div`
  ${Styles}
`;
